// extracted by mini-css-extract-plugin
export default {"textAreaClass":"src-components-Antd-TextArea-TextArea__textAreaClass--bUSIY"};